interface Props {
  dark?: boolean;
  size?: number;
}

const SvgGetApp: React.FC<Props> = ({ dark, size = 18 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.1875 1.5C5.26219 1.5 4.5 2.26219 4.5 3.1875V14.8125C4.5 15.7378 5.26219 16.5 6.1875 16.5H11.8125C12.7378 16.5 13.5 15.7378 13.5 14.8125V3.1875C13.5 2.26219 12.7378 1.5 11.8125 1.5H6.1875ZM6.1875 2.625H11.8125C12.1299 2.625 12.375 2.87006 12.375 3.1875V14.8125C12.375 15.1299 12.1299 15.375 11.8125 15.375H6.1875C5.87006 15.375 5.625 15.1299 5.625 14.8125V3.1875C5.625 2.87006 5.87006 2.625 6.1875 2.625ZM9 13.125C8.85082 13.125 8.70774 13.1843 8.60225 13.2898C8.49676 13.3952 8.4375 13.5383 8.4375 13.6875C8.4375 13.8367 8.49676 13.9798 8.60225 14.0852C8.70774 14.1907 8.85082 14.25 9 14.25C9.14918 14.25 9.29226 14.1907 9.39775 14.0852C9.50324 13.9798 9.5625 13.8367 9.5625 13.6875C9.5625 13.5383 9.50324 13.3952 9.39775 13.2898C9.29226 13.1843 9.14918 13.125 9 13.125Z"
        className={`${dark ? "fill-dark" : "fill-primary"}`}
      />
    </svg>
  );
};

export default SvgGetApp;
